import React, { useCallback, useEffect, useState } from "react";
import s from './ItemHomework.module.css';
import { useNavigate } from "react-router-dom";
import {getData, postData,postFormData} from '../middleware/apiMiddleware';
import {Button} from 'react-bootstrap';
import {GreenButton} from './MyButton';

export default function ItemHomework(prop) {	
	const navigate = useNavigate();
	let itemId = prop.itemId;
	
	const [homework, setHomework] = useState([]);
	
	const fetchData = () => {
		getData('item/getItemHomework?itemId=' + itemId, navigate)
		.then(res => {			
				setHomework(res.data);
			}
		);
	}
	
	
	useEffect(() => {
		fetchData();
	}, []);

	const [selectedFile, setSelectedFile] = useState(null);
	
	const pdfFileHandler = (e) => {
		setSelectedFile(e.target.files[0]);
	};

	const uploadHomework = async (e) => {
    e.preventDefault();
		try {			
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("generalfile", selectedFile);
			
      let res = await postFormData("utility/uploadHomework", data, navigate);
			fetchData();
    } catch (err) {
      console.log(err);
    }
  };
	
	const updateHw = async (hOrdering, hTitle, homeworkLink) => {
		let obj = {
			'itemId' : itemId,
			'hOrdering' : hOrdering,
			'hTitle' : hTitle,
			'homeworkLink' : homeworkLink,
		}
		await postData("item/updateHw", obj, navigate); 
		
		fetchData();
	}
	
	const deleteHw = async (hOrdering) => {
		let obj = {
			'itemId' : itemId,
			'hOrdering' : hOrdering,
		}
		await postData("item/deleteHw", obj, navigate); 
		
		fetchData();
	}

	return (<div className={s.main_holder}>
		{
			homework.map((h, indexH) => (<div className={s.homeworkInput}>
				<div className={s.inputHolder}>
					<div>Title</div>
					<input className={s.inputBox} type="text" value={h.hTitle} onChange={(e)=> {
						homework[indexH]['hTitle'] = e.target.value;
						setHomework([...homework])
					}} />
					<div>Image</div>
					<input className={s.inputBox} type="text" value={h.homeworkLink} onChange={(e)=> {
						homework[indexH]['homeworkLink'] = e.target.value;
						setHomework([...homework])
					}} />
					<div style={{display:"flex"}}>
						<div style={{marginRight:"20px"}}>
							<GreenButton isEnabled={true} clickedAction={()=>{updateHw(h.hOrdering, h.hTitle, h.homeworkLink)}} bText={"update"} />
						</div>
						<div>
							<GreenButton isEnabled={true} clickedAction={()=>{deleteHw(h.hOrdering)}} bText={"delete"} />
						</div>
					</div>
				
				</div>
				
				
				<img className={s.hwImg} src={"https://ehla-media-bucket.s3.amazonaws.com/" + h.homeworkLink} />
			</div>))
		}
		
		<div style={{display:"flex"}}>
			<div >
				<Button style={{ whiteSpace: "nowrap"}} variant={selectedFile== null ? "secondary": "primary"} type="submit" onClick={uploadHomework} disabled={selectedFile== null}>
					New Homework
				</Button>
			</div>
			<div  style={{marginLeft:"20px", width:"100%"}} >
				<input className="form-control" type="file" onChange={pdfFileHandler}  />
			</div>
		</div>
		
	</div>);
}

